// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oauth-wrapper {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   gap: 18px;
   min-height: 60vh;
   text-align: center;
}

.oauth-wrapper .logo {
   width: 160px;
   max-width: 60vw;
}

.oauth-wrapper .message {
   font-size: 18px;
   color: var(--primary, #2b2b2b);
}

.oauth-wrapper .message.error {
   color: #d32f2f;
}

.oauth-wrapper .account-info .detail {
   display: flex;
   flex-direction: column;
}

.oauth-wrapper .account-info .name {
   font-size: 16px;
   font-weight: 500;
}

.oauth-wrapper .account-info .username {
   font-size: 13px;
   color: #888;
}

.oauth-wrapper .link {
   cursor: pointer;
   color: #1976d2;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/oauth/oauth.component.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,sBAAsB;GACtB,mBAAmB;GACnB,uBAAuB;GACvB,SAAS;GACT,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,eAAe;AAClB;;AAEA;GACG,eAAe;GACf,8BAA8B;AACjC;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,WAAW;AACd;;AAEA;GACG,eAAe;GACf,cAAc;AACjB","sourcesContent":[".oauth-wrapper {\n   display: flex;\n   flex-direction: column;\n   align-items: center;\n   justify-content: center;\n   gap: 18px;\n   min-height: 60vh;\n   text-align: center;\n}\n\n.oauth-wrapper .logo {\n   width: 160px;\n   max-width: 60vw;\n}\n\n.oauth-wrapper .message {\n   font-size: 18px;\n   color: var(--primary, #2b2b2b);\n}\n\n.oauth-wrapper .message.error {\n   color: #d32f2f;\n}\n\n.oauth-wrapper .account-info .detail {\n   display: flex;\n   flex-direction: column;\n}\n\n.oauth-wrapper .account-info .name {\n   font-size: 16px;\n   font-weight: 500;\n}\n\n.oauth-wrapper .account-info .username {\n   font-size: 13px;\n   color: #888;\n}\n\n.oauth-wrapper .link {\n   cursor: pointer;\n   color: #1976d2;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
